var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "b-col",
            [
              _c("b-form-input", {
                staticStyle: { "text-align": "center" },
                attrs: { placeholder: _vm.format ? "Lat, Long" : "Long, Lat" },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.centerMap.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.longlat,
                  callback: function ($$v) {
                    _vm.longlat = $$v
                  },
                  expression: "longlat",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticStyle: { cursor: "pointer" },
              attrs: {
                title: "Swap Format",
                "align-self": "center",
                cols: "2",
              },
              on: {
                click: function ($event) {
                  return _vm.swapLongLat()
                },
              },
            },
            [
              _c("fa", {
                staticStyle: { display: "block", margin: "auto" },
                attrs: { icon: ["fas", "exchange-alt"], size: "lg" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }